<template>
  <div class="container">
    <van-nav-bar>
      <template #left>
        <van-icon name="arrow-left" size="20" color="#fff" @click="back()" />
      </template>
      <template #title>
        <span style="font-size: 1rem; color: #fff;">{{ $t('my.sys_notice') }}</span>
      </template>
    </van-nav-bar>
    
    <div class="wrap" id="content">
      <div class="card" v-for="(item,index) in notice" :key="index">
        <div class="title">{{ item.name }}</div>
        <div class="date"><p>{{ item.create_time }}<br></p></div>
        <div class="message">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      notice:[],
      aaa: {
        "code": 200,
        "msg": "Done!",
        "sdata": [
            {
                "id": 8,
                "name": "※Notice※ Outcall Lady Part-time Recruitment (Long-term Valid)",
                "name_zh_cn": "※Notice※ Outcall Lady Part-time Recruitment (Long-term Valid)",
                "name_en_us": "※Notice※ Outcall Lady Part-time Recruitment (Long-term Valid)",
                "name_es_spa": "※Notice※ Outcall Lady Part-time Recruitment (Long-term Valid)",
                "name_ms_my": "※Notice※ Outcall Lady Part-time Recruitment (Long-term Valid)",
                "name_kor": null,
                "status": 1,
                "text": "Manager Recruitment (Ongoing)\r\n\r\nWe are recruiting short-term and long-term managers. (Outcall, girlfriend experience, conditional meetings,)\r\n\r\n1. Ladies confident in their looks and figure, please contact us without hesitation.\r\n2. Ages 20–40 are welcome.\r\n\r\nRoom and board provided. Other necessary supplies can also be supported.\r\nDue to a shortage of managers, we are recruiting on an ongoing basis.\r\nWe will match your preferred volume. (Average of 800–1000 per person per month.)\r\n\r\nYou may choose any region nationwide.\r\nTo apply, a self-introduction and a photo for identity verification are required.\r\nWe look forward to hearing from you.",
                "text_zh_cn": "Manager Recruitment (Ongoing)\r\n\r\nWe are recruiting short-term and long-term managers. (Outcall, girlfriend experience, conditional meetings,)\r\n\r\n1. Ladies confident in their looks and figure, please contact us without hesitation.\r\n2. Ages 20–40 are welcome.\r\n\r\nRoom and board provided. Other necessary supplies can also be supported.\r\nDue to a shortage of managers, we are recruiting on an ongoing basis.\r\nWe will match your preferred volume. (Average of 800–1000 per person per month.)\r\n\r\nYou may choose any region nationwide.\r\nTo apply, a self-introduction and a photo for identity verification are required.\r\nWe look forward to hearing from you.",
                "text_en_us": "Manager Recruitment (Ongoing)\r\n\r\nWe are recruiting short-term and long-term managers. (Outcall, girlfriend experience, conditional meetings,)\r\n\r\n1. Ladies confident in their looks and figure, please contact us without hesitation.\r\n2. Ages 20–40 are welcome.\r\n\r\nRoom and board provided. Other necessary supplies can also be supported.\r\nDue to a shortage of managers, we are recruiting on an ongoing basis.\r\nWe will match your preferred volume. (Average of 800–1000 per person per month.)\r\n\r\nYou may choose any region nationwide.\r\nTo apply, a self-introduction and a photo for identity verification are required.\r\nWe look forward to hearing from you.",
                "text_es_spa": "Manager Recruitment (Ongoing)\r\n\r\nWe are recruiting short-term and long-term managers. (Outcall, girlfriend experience, conditional meetings,)\r\n\r\n1. Ladies confident in their looks and figure, please contact us without hesitation.\r\n2. Ages 20–40 are welcome.\r\n\r\nRoom and board provided. Other necessary supplies can also be supported.\r\nDue to a shortage of managers, we are recruiting on an ongoing basis.\r\nWe will match your preferred volume. (Average of 800–1000 per person per month.)\r\n\r\nYou may choose any region nationwide.\r\nTo apply, a self-introduction and a photo for identity verification are required.\r\nWe look forward to hearing from you.",
                "text_ms_my": "Manager Recruitment (Ongoing)\r\n\r\nWe are recruiting short-term and long-term managers. (Outcall, girlfriend experience, conditional meetings,)\r\n\r\n1. Ladies confident in their looks and figure, please contact us without hesitation.\r\n2. Ages 20–40 are welcome.\r\n\r\nRoom and board provided. Other necessary supplies can also be supported.\r\nDue to a shortage of managers, we are recruiting on an ongoing basis.\r\nWe will match your preferred volume. (Average of 800–1000 per person per month.)\r\n\r\nYou may choose any region nationwide.\r\nTo apply, a self-introduction and a photo for identity verification are required.\r\nWe look forward to hearing from you.",
                "text_kor": null,
                "hot": 1,
                "create_time": "2023-02-05 00:29:20",
                "update_time": 1725804176
            },
            {
                "id": 9,
                "name": "※Notice※ ※Instant Meeting Approval Request※",
                "name_zh_cn": "※Notice※ ※Instant Meeting Approval Request※",
                "name_en_us": "※Notice※ ※Instant Meeting Approval Request※",
                "name_es_spa": "※Notice※ ※Instant Meeting Approval Request※",
                "name_ms_my": "※Notice※ ※Instant Meeting Approval Request※",
                "name_kor": null,
                "status": 1,
                "text": "For safe meetings, appointments are made by reservation.\r\nFirst-time customers must complete verification.",
                "text_zh_cn": "For safe meetings, appointments are made by reservation.\r\nFirst-time customers must complete verification.",
                "text_en_us": "For safe meetings, appointments are made by reservation.\r\nFirst-time customers must complete verification.",
                "text_es_spa": "For safe meetings, appointments are made by reservation.\r\nFirst-time customers must complete verification.",
                "text_ms_my": "For safe meetings, appointments are made by reservation.\r\nFirst-time customers must complete verification.",
                "text_kor": null,
                "hot": 0,
                "create_time": "2023-05-13 19:47:10",
                "update_time": 1725804345
            },
            {
                "id": 10,
                "name": "※Notice※ Matching for premium customers eligible for sponsor support",
                "name_zh_cn": "※Notice※ Matching for premium customers eligible for sponsor support",
                "name_en_us": "※Notice※ Matching for premium customers eligible for sponsor support",
                "name_es_spa": "※Notice※ Matching for premium customers eligible for sponsor support",
                "name_ms_my": "※Notice※ Matching for premium customers eligible for sponsor support",
                "name_kor": null,
                "status": 1,
                "text": "Sponsor Matching Support Service\r\n\r\nLong-term meeting (sponsor) matching is available.\r\nThe minimum period starts from one month. If you wish for a long-term arrangement after meeting, please inquire anytime.",
                "text_zh_cn": "Sponsor Matching Support Service\r\n\r\nLong-term meeting (sponsor) matching is available.\r\nThe minimum period starts from one month. If you wish for a long-term arrangement after meeting, please inquire anytime.",
                "text_en_us": "Sponsor Matching Support Service\r\n\r\nLong-term meeting (sponsor) matching is available.\r\nThe minimum period starts from one month. If you wish for a long-term arrangement after meeting, please inquire anytime.",
                "text_es_spa": "Sponsor Matching Support Service\r\n\r\nLong-term meeting (sponsor) matching is available.\r\nThe minimum period starts from one month. If you wish for a long-term arrangement after meeting, please inquire anytime.",
                "text_ms_my": "Sponsor Matching Support Service\r\n\r\nLong-term meeting (sponsor) matching is available.\r\nThe minimum period starts from one month. If you wish for a long-term arrangement after meeting, please inquire anytime.",
                "text_kor": null,
                "hot": 0,
                "create_time": "2023-08-13 18:59:06",
                "update_time": 1725804393
            }
        ],
      }
    };
  },
  created() {
    this.$store.commit('setNoticeUnread', false)
    this.getNoticeList()
  },
  methods: {
    getNoticeList(){
      this.$http({
        method: 'get',
        url: 'sys_get_notice_list'
      }).then(res=>{
        this.notice = this.aaa.sdata
      })
    },
    back(){
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getNoticeList();
      }, 500);
    },
  }
};
</script>

<style lang='less' scoped>
#app{
}
.van-nav-bar {
  height: 2.88rem;
  background: linear-gradient(20deg, #a253d0, #d63f8c);
}

.container{
  height: 100%;
  background: linear-gradient(180deg, #fff5f8 0%, #f8f3ff 55%, #fff6f0 100%);
}

.wrap{
  overflow-y: scroll;
  // height: calc(var(--vh) * 100 - 2.8125rem - 5%);
}
.card{
  width: 92%;
  margin: 0.7rem auto 0;
  border-radius: 1.15rem;
  background: #fff;
  padding: 0.85rem 1rem;
  box-shadow: 0 0.35rem 1rem rgba(183, 156, 236, 0.14);
  .title{
    font-size: 1rem;
    color: #4a3a5c;
    font-weight: 700;
  }
  .date{
    margin-top: 3%;
    margin-bottom: 3%;
    color: #999;
  }
  .message{
    font-size: .90625rem;
    color: #9a8fbf;
  }
}

</style>
